import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { CreateOrUpdatePayloadType } from '../schema';

import { useConstructor } from './use-constructor';

export function useConstructorCreateOrUpdate() {
  const qc = useQueryClient();
  const {
    createOrUpdate,
    methods: { setCreateOrUpdate }
  } = useConstructor();
  const [{ page = 1, ...searchArg }] = useQueryParams({
    page: NumberParam,
    search: StringParam,
    dominant: StringParam,
    startDate: StringParam,
    finishDate: StringParam
  });

  return useMutation(
    async (payload: CreateOrUpdatePayloadType) => {
      const { data } = await $api.post('/v1/excel-constructor/custom-template', payload);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries(['all-constructors', page, searchArg]);

        setCreateOrUpdate({
          ...createOrUpdate,
          visible: false
        });

        showMessage(data?.message, true);
      }
    }
  );
}
